import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const EditchanneltypeApi = createAsyncThunk(
  "auth/Editchanneltype",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      const response = await AuthAxios.patch(apiRoutes.channelTypeAction("update",1,data.id,1),data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }

const EditchanneltypeSlice = createSlice({
  name: "Edit channeltype",
  initialState:intialState,
  reducers: {
    resetChannelType: () => intialState,
},
  extraReducers: (builder) => {
    builder.addCase(EditchanneltypeApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditchanneltypeApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditchanneltypeApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetChannelType } = EditchanneltypeSlice.actions;
export const Editchanneltypereducer = EditchanneltypeSlice.reducer;
